import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IConfig } from '@cian/config/shared';
import { fetchGetUserData, TGetUserDataResponse } from '../../repositories/users/v1/get-user-data';
import { TUserResolve } from '../../types/currentUser';

interface IDependencies {
  config: IConfig;
  httpApi: IHttpApi;
  logger: ILogger;
}

export async function resolveUser({ httpApi, logger }: IDependencies): Promise<TUserResolve> {
  try {
    const userDataResponse = (await fetchGetUserData({
      httpApi,
    })) as TGetUserDataResponse;

    const userData = userDataResponse.response?.user;

    if (!userData || !userData.cianUserId || !userData.realtyUserId) {
      return null;
    }

    return {
      cianUserId: userData.cianUserId,
      realtyUserId: userData.realtyUserId,
      phone: userData.phone ?? undefined,
      phoneConfirmed: userData.phoneConfirmed,
      email: userData.email ?? undefined,
      firstName: userData.firstName ?? undefined,
      lastName: userData.lastName ?? undefined,
      displayName: userData.displayName ?? undefined,
    };
  } catch (err) {
    // код 400 ожидаемый, если пользователь не авторизован
    if (err.statusCode === 400) {
      return null;
    }

    logger.error(err, {
      message: err.message,
      stack: err.stack,
      comment: 'Ошибка запроса в get-user-data',
    });

    return null;
  }
}
